import script from "./EventCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./EventCalendar.vue?vue&type=script&setup=true&lang=js"

import "./EventCalendar.vue?vue&type=style&index=0&id=07368dc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07368dc0"]])

export default __exports__